import { afterNavigate } from "$app/navigation";

import { tick } from "svelte";

/**
 * Work around a SvelteKit issue where #hash anchors don't reliably scroll
 * into view during client-side navigation.
 * @see https://github.com/sveltejs/kit/issues/4216
 */
export function useScrollHashIntoView(): void {
  afterNavigate(async () => {
    const hash = window.location.hash;
    if (hash) {
      await tick(); // without this, element is null because the DOM isn't updated yet
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  });
}
